module.exports = __webpack_public_path__ + "img/01other-nizi2021.7fff4ff2.png";